
import {refugiosService} from "@/data";
import {cartoHelpers} from "@/helpers/carto-helpers";

const state = () => ({
    all: [],
    geoJson: null
});

const getters = {
    refugiosBuenos: (state) => (fecha, plazas) => {
        return state.all.filter( ref => {
            (!ref.fechas[fecha].cerrado && !ref.fechas[fecha].online && ref.fechas[fecha].plazas <= plazas)
        })
    }
}

const actions = {
    getAllRefugios({commit}) {
        refugiosService.getRefugios().then(data => {
            commit('setRefugios', data)
        })
    }
}

const mutations = {
    setRefugios(state, refugios) {
        refugios.forEach( elemento => {
            state.all.push(cartoHelpers.setProperties(elemento));
        })
        state.geoJson = cartoHelpers.fromApiToMapPoints(refugios)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}